/*
 *
 * BiometricDialog
 *
 * @version 1.0.0
 * @author Elia Minozzi
 * @since 01-Apr-2025
*/

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { nullSafe } from 'Utility/globalMethods'
import BiometricDialog from './BiometricDialog'
import { doHidePopup } from 'Store/actions/popup'
import * as LoginAppActions from 'Store/actions/login'

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(LoginAppActions, dispatch),
  doHidePopup: () => dispatch(doHidePopup())
})

const mapStateToProps = state => ({
  data: nullSafe(() => state.popup.popupInfo, {})
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(BiometricDialog)
